import React, { FunctionComponent, memo, ReactElement } from 'react'
import styled from 'styled-components'
import { BaseFontProps, ClickableProps, NumberOfLinesProps } from '../../styles/types'
import { clickable, text } from '../../styles'
import { numberOfLines } from '../../styles/properties/numberOfLines'
import Touchable from '../Touchable'
import { defaultTextStyle, FloatingTextProps, onPress } from './FloatingTextUtility'

type BaseTextProps = BaseFontProps & ClickableProps & NumberOfLinesProps

export const BaseText = styled.span.attrs((props: BaseTextProps) => ({
    'data-testid': props.testID,
}))<BaseTextProps>`
    ${numberOfLines}
    ${text}
    ${clickable}
`

export const FloatingText: FunctionComponent<FloatingTextProps> = ({
    textObjects,
    textAlign,
    backgroundColor,
    numberOfLines,
    lineHeight,
}): ReactElement => {
    return (
        <BaseText
            testID="main-text-node"
            numberOfLines={numberOfLines}
            textAlign={textAlign}
            backgroundColor={backgroundColor}
            lineHeight={lineHeight}
        >
            {textObjects.map(textObject => {
                const {
                    content,
                    onPress: onPressText,
                    skipDebounce,
                    textStyle,
                    href,
                    webHeadlineType,
                } = textObject
                const text = (
                    <BaseText
                        key={content}
                        as={webHeadlineType}
                        pointer={!!onPressText || !!href}
                        onClick={onPress(skipDebounce, onPressText)}
                        display="inline"
                        {...{ ...defaultTextStyle, ...textStyle }}
                    >
                        {content}
                    </BaseText>
                )
                return href ? (
                    <Touchable key={`touchable-${content}`} href={href}>
                        {text}
                    </Touchable>
                ) : (
                    text
                )
            })}
        </BaseText>
    )
}

export default memo(FloatingText)
